// export const BASE_URL = 'http://beeserver:8070/api'
// export const BASE_URL = 'https://api.midadworld.com/api'
export const BASE_URL = 'https://api.albunyan-hardware.com/api'

export const BYTE_RANGE_URL = BASE_URL + '/stream'